import api from "../api/api"

const get = (masters) => {
    return new Promise((resolve, reject)=>{
        api.get('system-masters/dd/'+masters.join()).then((res) => {
            //console.log(res.data);
            let allMasters = res.data;
            let data = {};
            for (const master in allMasters) {
                if(!allMasters[master].error){
                    data[master] = allMasters[master].data;
                }
            }
            resolve(data);
        }).catch(error =>{
            reject("Something went wrong while loading masters");
        })
    })
}


const contextServices = {
    get,
}

export default contextServices;